import React from "react";
import styles from "./callhistory.module.css";
import CallRow from "./callrow";
import { formatPhone, formatMd, formatElapsed, formatDateDivider } from "./callhistoryformat";

//우측 카드: 헤더(이름·번호·통화 N회·첫 접촉) + [고객 정보][숨김] + 콜백 경고 바 + 통화 행 목록
const CallDetail : React.FC<any> = (props) => {
    const c = props.contact;

    if (!props.selectedPhone) {
        return (
            <div className={`${styles.card} ${styles.rightCard}`}>
                <div className={styles.emptyDetail}>왼쪽에서 고객을 선택하면 통화 이력이 표시됩니다</div>
            </div>
        );
    }

    const rows : React.ReactNode[] = [];
    let lastDate = "";
    (props.calls || []).forEach((call : any) => {
        const date = (call.startedAt || "").split(" ")[0];
        if (date && date !== lastDate) {
            lastDate = date;
            rows.push(<div key={`d-${date}`} className={styles.dateDivider}>{formatDateDivider(call.startedAt)}</div>);
        }
        rows.push(
            <CallRow
                key={call.callId}
                call={call}
                now={props.now}
                journey={props.journeys[call.callId]}
                onLoadJourney={props.onLoadJourney}
                onTranscript={props.onTranscript}
            />
        );
    });

    return (
        <div className={`${styles.card} ${styles.rightCard}`}>
            <div className={styles.detailHeader}>
                <div className={styles.detailTitle}>
                    <span className={styles.detailName}>{c ? (c.displayName || formatPhone(c.phoneNumber)) : formatPhone(props.selectedPhone)}</span>
                    {
                        c ?
                            <span className={styles.detailMeta}>
                                {formatPhone(c.phoneNumber)} · 통화 {c.totalCalls}회{c.firstContactAt ? ` · 첫 접촉 ${formatMd(c.firstContactAt)}` : ""}
                            </span>
                            : ""
                    }
                </div>
                <div className={styles.detailButtons}>
                    <button className={styles.outlineBtn} onClick={props.onProfile}>고객 정보</button>
                    {c ? <button className={styles.outlineBtn} onClick={() => props.onToggleHidden(c)}>{c.hidden ? "숨김 해제" : "숨김"}</button> : null}
                </div>
            </div>
            {
                c && c.callbackNeeded ?
                    <div className={styles.callbackBar}>
                        <div><b>콜백 대기 {formatElapsed(c.callbackSince, props.now)}</b> — 마지막 전화를 받지 못했습니다</div>
                        <button className={styles.callbackLink} onClick={props.onCallbackDone}>처리됨으로 표시</button>
                    </div>
                    : null
            }
            <div className={styles.callList}>
                {
                    props.callsLoading && rows.length === 0 ?
                        <div className={styles.emptyDetail}>불러오는 중...</div>
                        : rows.length === 0 ?
                            <div className={styles.emptyDetail}>통화 기록이 없습니다</div>
                            : rows
                }
            </div>
        </div>
    );
};

export default CallDetail;
